<template>
  <v-app class="scrollbar-hidden" v-if="!viewRequiresAuth()">
    <router-view></router-view>
  </v-app>

  <v-app class="scrollbar-hidden" v-else>
    <v-navigation-drawer
      :model-value="$store.state.sidebar.drawer"
      @update:model-value="setDrawer"
      floating
      :rail="isRail"
      :expand-on-hover="isRail"
      @update:rail="hovering = !$event"
      :width="240"
      dark
      app
      class="rounded-0"
      :permanent="!isMobile"
      :temporary="isMobile"
    >
      <Sidebar :expanded="expanded"></Sidebar>
    </v-navigation-drawer>

    <v-app-bar class="elevation-0" height="48" dense app>
      <Header></Header>
    </v-app-bar>
    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
import Header from "@/components/Header.vue";
import Sidebar from "@/components/Sidebar.vue";
export default {
  name: "App",
  components: { Header, Sidebar },
  data: () => ({
    //Hover sobre el drawer en modo rail. Lo informa vuetify via `update:rail` (unica fuente
    //de verdad del hover: el Sidebar ya no maneja mouseenter/mouseleave por su cuenta).
    hovering: false,
  }),
  computed: {
    isMobile() {
      return this.$vuetify.display.mdAndDown;
    },
    isRail() {
      return !this.$store.state.sidebar.open && !this.isMobile;
    },
    //Si el contenido del sidebar se ve completo (logo grande + titulos de los items)
    expanded() {
      if (this.isMobile) return true;
      return this.$store.state.sidebar.open || this.hovering;
    },
  },
  watch: {
    isRail(val) {
      if (!val) this.hovering = false;
    },
  },
  created() {
    document.title = "ERG - Warehouse Managment System";
    //El estado inicial del drawer depende del viewport, no de lo que haya quedado guardado.
    this.$store.commit("setOpenSidebar", { drawer: !this.isMobile });
  },
  mounted() {
    window.document.title = "ERG - Warehouse Managment System";
  },
  methods: {
    viewRequiresAuth() {
      return this.$route.matched.some((record) => record.meta.requiresAuth);
    },
    setDrawer(value) {
      this.$store.commit("setOpenSidebar", { drawer: value });
    },
  },
};
</script>
